import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { dateString, dateUTCString } from '../../core/utils';
import { DateViewComponent } from './date-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-date-input',
    templateUrl: 'date-input.component.html',
    styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class DateInputComponent extends DateViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	override onChange(changes?: SimpleChanges | undefined): void {
		if (!this.datum && this.model) this.datum = dateString(this.model);
		super.onChange(changes);
	}

	onDateChange() {
		this.model = this.datum ? dateUTCString(this.datum) : undefined;
		this.vs.dirty.next(true);
		this.modelChange.emit(this.model);
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
